import { Component, inject } from '@angular/core';

import { ApplicationStatus } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { SettingsService } from 'src/app/services/settings.service';
import * as utils from 'src/app/utils/misc.utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  auth = inject(AuthService);
  settings = inject(SettingsService);

  requestUpgrade = false;
  year = environment.currentAwardYear;
  Status = ApplicationStatus;
  utils = utils;

  nominatorBackground() {
    if (!utils.isEligibleToNominate(this.auth.currentUser, this.year)) {
      return 'inherit';
    }
    if (this.settings.isNominationOpen(this.auth.currentUser) && !this.settings.isPastNominationDeadline()) {
      return 'lightyellow';
    }
    return 'inherit';
  }

  voterBackground() {
    if (this.settings.isVotingOpen(this.auth.currentUser) && !this.settings.isPastVotingDeadline()) {
      return 'lightyellow';
    }
    return 'inherit';
  }
}
